import { DataTable } from "primereact/datatable";
import { ApiLotteryData } from "../model/adminLottery.model";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Badge } from "primereact/badge";

interface Props {
  lotteryData: ApiLotteryData[];
  setDataLotteryRow: (data: ApiLotteryData) => void;
  setDialogEditLottery: (data: boolean) => void;
}

function TableLottery({
  lotteryData,
  setDataLotteryRow,
  setDialogEditLottery,
}: Props): JSX.Element {
  const [globalFilter, setGlobalFilter] = useState<string | null>(null);

  const headerSearch = (
    <div className="flex justify-content-end">
      <InputText
        type="text"
        placeholder="Buscar..."
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setGlobalFilter(e.target.value)
        }
        style={{
          backgroundColor: "#ffffff",
          border: "1px solid #cbd5e1",
          color: "#333333",
          borderRadius: "6px",
          padding: "0.5rem 0.75rem",
          width: "220px",
        }}
      />
    </div>
  );

  return (
    <div>
      <style>{`
        /* Header columnas */
        .lottery-main-table .p-datatable-thead > tr > th {
          background-color: #f8fafc !important;
          color: #374151 !important;
          border-bottom: 2px solid #e5e7eb !important;
          border-color: #e5e7eb !important;
          font-size: 0.78rem !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.05em !important;
          padding: 0.85rem 1rem !important;
        }

        /* Filas */
        .lottery-main-table .p-datatable-tbody > tr {
          background-color: #ffffff !important;
          color: #374151 !important;
          transition: background 0.15s ease !important;
        }
        .lottery-main-table .p-datatable-tbody > tr:hover {
          background-color: #f0fdf9 !important;
        }
        .lottery-main-table .p-datatable-tbody > tr > td {
          border-color: #f1f5f9 !important;
          padding: 0.85rem 1rem !important;
          color: #374151 !important;
          font-size: 0.9rem !important;
        }

        /* Iconos sort */
        .lottery-main-table .p-sortable-column-icon {
          color: #9ca3af !important;
        }
        .lottery-main-table .p-sortable-column:hover {
          background-color: #f1f5f9 !important;
          color: #374151 !important;
        }
        .lottery-main-table .p-highlight .p-sortable-column-icon {
          color: #00A86B !important;
        }

        /* Header DataTable (buscador) */
        .lottery-main-table .p-datatable-header {
          background-color: #ffffff !important;
          border: none !important;
          padding: 0 0 0.75rem 0 !important;
        }

        /* Paginador */
        .lottery-main-table .p-paginator {
          background-color: #ffffff !important;
          border-top: 1px solid #e5e7eb !important;
        }
        .lottery-main-table .p-paginator .p-paginator-page.p-highlight {
          background-color: #00A86B !important;
          color: #ffffff !important;
          border-color: #00A86B !important;
        }
        .lottery-main-table .p-paginator .p-paginator-element {
          color: #374151 !important;
        }

        /* Gridlines */
        .lottery-main-table .p-datatable-gridlines .p-datatable-tbody > tr > td {
          border-color: #f1f5f9 !important;
        }
        .lottery-main-table .p-datatable-gridlines .p-datatable-thead > tr > th {
          border-color: #e5e7eb !important;
        }

        /* Botón editar — quitar azul */
        .lottery-main-table .p-button.p-button-info {
          background-color: #00A86B !important;
          border-color: #00A86B !important;
          color: #ffffff !important;
        }
        .lottery-main-table .p-button.p-button-info:hover {
          background-color: #008f5a !important;
          border-color: #008f5a !important;
        }

        /* Placeholder buscador */
        .lottery-main-table-search::placeholder {
          color: #9ca3af !important;
          opacity: 1 !important;
        }
      `}</style>

      <DataTable
        value={lotteryData}
        resizableColumns
        showGridlines
        tableStyle={{ minWidth: "50rem" }}
        emptyMessage="No hay resultados"
        globalFilter={globalFilter}
        header={headerSearch}
        paginator={lotteryData.length > 5}
        rows={5}
        rowsPerPageOptions={[5, 10, 25, 50]}
        className="lottery-main-table"
        style={{ borderRadius: "8px", overflow: "hidden", border: "1px solid #e5e7eb" }}
      >
        <Column field="idLottery" header="ID" sortable style={{ width: "5%" }} />
        <Column field="descriptionLottery" header="Descripción del sorteo" sortable style={{ width: "22%" }} />
        <Column field="numberLottery" header="Número ganador" sortable style={{ width: "12%" }} />
        <Column field="rewardLottery" header="Valor ganancia" sortable style={{ width: "12%" }} />
        <Column field="dateLottery" header="Fecha registro" sortable style={{ width: "13%" }} />
        <Column field="dateEndLottery" header="Fecha finaliza sorteo" sortable style={{ width: "14%" }} />
        <Column
          field="stateLottery"
          header="Estado"
          sortable
          style={{ width: "10%" }}
          body={(data: ApiLotteryData) => (
            <Badge
              value={data.stateLottery ? "Activo" : "Inactivo"}
              severity={data.stateLottery ? "success" : "danger"}
            />
          )}
        />
        <Column
          header="Acciones"
          style={{ width: "8%", textAlign: "center" }}
          body={(data: ApiLotteryData) => (
            <div className="flex justify-content-center">
              <Button
                tooltip="Editar sorteo"
                tooltipOptions={{ position: "top" }}
                icon="pi pi-pencil"
                className="p-button-rounded p-button-info"
                onClick={() => {
                  setDataLotteryRow(data);
                  setDialogEditLottery(true);
                }}
              />
            </div>
          )}
        />
      </DataTable>
    </div>
  );
}

export default TableLottery;